module.exports = __webpack_public_path__ + "static/media/loading.92a4a31e.gif";